import styled from 'styled-components';

export const LogoContainer = styled.div`
  img {
    height: 24px;
  }
`;

export const ComptrollerNameContainer = styled.div`
  color: #fff;
  box-shadow: 0 0 15px 0 rgb(0 0 0 / 20%);
  font-size: 0.9em;
  text-align: right;
  float: right;
  #comptroller-name {
    font-weight: 900;
  }
`;
